export const TRANSACTION_REQUEST = 'TRANSACTION_REQUEST';
export const TRANSACTION_DATA = 'TRANSACTION_DATA';
export const TRANSACTION_ERROR = 'TRANSACTION_ERROR';


